import { User, UserCompetition, UserExternal } from '@vote4dance/judging-schema';
import { CompetitionId, UserId } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

type UserItemCompanion = {
    getFullName(user: UserItem): string
}
export type UserItem = User & {
    user_id: string;
    federation_count: number;
    organization_count: number;
}

export const UserItem: UserItemCompanion = {
    getFullName(user: UserItem): string {
        return user.user_firstname + ' ' + user.user_lastname;
    }
}

export function UserSource(user_id?: UserId) {
    return new StreamSource<UserItem[]>(user_id ? `/user/${user_id}` : '/user');
}

export type UserCompetitionItem = UserCompetition
& Pick<User, 'user_firstname' | 'user_lastname' | 'user_email'>
& {
    competition_count: number,
}

type UserCompetitionItemCompanion = {
    getFullName(judge: UserCompetitionItem): string
}

export const UserCompetitionItem: UserCompetitionItemCompanion = {
    getFullName(user: UserCompetitionItem): string {
        return user.user_firstname + ' ' + user.user_lastname;
    }
}

export function CompetitionUsersSource(competition_id: CompetitionId) {
    return new StreamSource<UserCompetitionItem[]>(`/competitionusers/${competition_id}`);
}

export function UserExternalSource(user_id: UserId) {
    return new StreamSource<UserExternal[]>(`/userexternal/${user_id}`);
}
